import {Component, OnInit, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-change-password-via-token',
  templateUrl: './change-password-via-token.component.html',
  styleUrls: ['./change-password-via-token.component.less']
})
export class ChangePasswordViaTokenComponent implements OnInit {

  public userName: string;
  public userNewPass: string;
  public userVerifyPass: string;
  @Input() tkn : string;
  public saving = false;

  private token: string;

  constructor(
    private readonly router: Router,
    private readonly auth: AuthService,
    private readonly activatedRoute: ActivatedRoute,
    public toast: ToastrService) {
  }

  public ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];

      console.log(this.token);
    });
  }

  public continue(): void {

    // First check for a user name entered
    if (this.userName.length < 1) {
      this.toast.error('Please enter a User Name.', '', {timeOut: 10000, closeButton: true});
      return;
    }

    // Now check for a password
    if (this.userNewPass.length < 1) {
      this.toast.error('Please enter a password.', '', {timeOut: 10000,closeButton: true});
      return;
    }  

    // Now test for the password match
    if (this.userNewPass !== this.userVerifyPass) {
      this.toast.error('Passwords do not match.', '', {timeOut: 10000, closeButton: true});
      return;
    }

    // If we got this far, the new password is good.. send to serve
    this.saving = true;

    const param = {
      token: this.token,
      userName: this.userName,
      password: this.userNewPass
    };

    this.auth.ResetPassword(param).subscribe((r: any) => {
        this.toast.success('Password updated successfully.', 'Update Succeeded!');
        this.saving = false;
        this.router.navigateByUrl('/login');
      },
      (err: any) => {
        this.toast.error('','There was an error updating your password.', {closeButton: true});
        let list = err.error.errors.forEach(er=>{
          this.toast.warning(er.description,'Password Update Error.', {timeOut: 10000, closeButton: true});

        }) //map(er=>er.description).join(';');
        this.saving = false;
      });

  }

  private testPasswordStrength(password: string): boolean {

    const lowercaseCheck = new RegExp('(?=.*[a-z])');
    const upperCaseCheck = new RegExp('(?=.*[A-Z])');
    const numericCheck = new RegExp('(?=.*[0-9])');
    const specialCharacterCheck = new RegExp('(?=.[!@#\$%\^&])');
    const lengthCheck = new RegExp('(?=.{8,})');

    if (!lowercaseCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {timeOut: 10000, closeButton: true});
      return false;
    } else if (!upperCaseCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {timeOut: 10000, closeButton: true});
      return false;
    } else if (!numericCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {timeOut: 10000, closeButton: true});
      return false;
    } else if (!specialCharacterCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {timeOut: 10000, closeButton: true});
      return false;
    } else if (!lengthCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {timeOut: 10000, closeButton: true});
      return false;
    }
    return true;
  }

}
